// frontend/src/components/QRDisplay.jsx

import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Printer, ExternalLink } from 'lucide-react';

function QRDisplay({ qrKey, printerName }) {
    const [qrImageSrc, setQrImageSrc] = useState('');
    
    // Domain & Local URLs
    const DOMAIN = "https://polyprint.apptests.work"; 
    const qrCodeUrl = `${DOMAIN}/maintenance?key=${qrKey}`; 
    const localUrl = `${window.location.origin}/maintenance?key=${qrKey}`;

    useEffect(() => {
        QRCode.toDataURL(qrCodeUrl, {
            width: 400, // Keep high resolution
            margin: 0,  
            errorCorrectionLevel: 'M'
        }, (err, url) => {
            if (err) console.error('QR Gen Error:', err);
            else setQrImageSrc(url);
        });
    }, [qrCodeUrl]);

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
            <head>
                <title>${printerName}</title>
                <style>
                    /* 1. Page Setup */
                    @page { 
                        size: 90mm 29mm landscape; 
                        margin: 0; 
                    }
                    body { 
                        margin: 0; 
                        padding: 0; 
                        width: 90mm; 
                        height: 29mm; 
                        font-family: sans-serif; 
                        overflow: hidden; 
                    }
                    
                    /* 2. Layout Container */
                    .label-container {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        padding: 0mm 2mm;
                        box-sizing: border-box;
                    }

                    /* 3. QR Section (Left) - ADJUSTED */
                    .qr-section {
                        width: 26mm; /* Adjusted width for new size */
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    /* ?? QR CODE SIZE: 22mm */
                    img.qr-code {
                        width: 22mm; 
                        height: 22mm; 
                        display: block;
                    }
                    
                    .url-text {
                        font-size: 5pt;
                        margin-top: 1px;
                        text-align: center;
                        white-space: nowrap;
                    }

                    /* 4. Text Section (Right) */
                    .text-section {
                        flex-grow: 1; 
                        padding-left: 1mm;
                        display: flex;
                        align-items: center;
                        justify-content: center; 
                        height: 100%;
                    }

                    .label-name {
                        font-size: 16pt; 
                        font-weight: bold;
                        line-height: 1.1;
                        word-wrap: break-word;
                        text-align: center; 
                        max-height: 26mm;
                        overflow: hidden;
                    }
                </style>
            </head>
            <body>
                <div class="label-container">
                    <div class="qr-section">
                        <img class="qr-code" src="${qrImageSrc}" />
                        <div class="url-text">Scan for Maint.</div>
                    </div>
                    <div class="text-section">
                        <div class="label-name">${printerName}</div>
                    </div>
                </div>
                <script>
                    window.onload = function() { window.focus(); setTimeout(() => { window.print(); }, 500); };
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <div style={{ margin: '10px 0', textAlign: 'center' }}>
            {/* On Screen Preview */}
            <div style={{ 
                border: '1px solid #e2e8f0', 
                padding: '15px', 
                display: 'inline-block', 
                borderRadius: '8px', 
                background: 'white' 
            }}>
                {qrImageSrc ? <img src={qrImageSrc} alt="QR" style={{ width: '128px', height: '128px' }} /> : <p>Generating...</p>}
                <div style={{ fontWeight: 'bold', marginTop: '10px', color: '#334155' }}>{printerName}</div>
            </div>
            <br />
            
            <button className="secondary" onClick={handlePrint} style={{ marginTop: '15px', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <Printer size={16} /> Print Label
            </button>

            <div style={{ marginTop: '10px', textAlign: 'center' }}>
                <a href={localUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.85rem', color: 'var(--primary)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                    Open Maintenance Form <ExternalLink size={14} />
                </a>
            </div>
        </div>
    );
}

export default QRDisplay;